import Header from './components/Header';
import Hero from './components/Hero';
import SectionTopics from './components/SectionTopics';
import SectionMedia from './components/SectionMedia';
import SectionAbout from './components/SectionAbout';
import SectionFaq from './components/SectionFaq';
import SectionContact from './components/SectionContact';
import SectionComments from './components/SectionComments';
import SectionFeatures from './components/SectionFeatures';
import SectionApp from './components/SectionApp';
import SectionCarousel from './components/SectionCarousel';
import SectionUpdates from './components/SectionUpdates';
import SectionCards from './components/SectionCards';
import SectionIndex from './components/SectionIndex';
import SectionRanking from './components/SectionRanking';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionTopics />
        <SectionMedia />
        <SectionAbout />
        <SectionFaq />
        <SectionContact />
        <SectionComments />
        <SectionFeatures />
        <SectionApp />
        <SectionCarousel />
        <SectionUpdates />
        <SectionCards />
        <SectionIndex />
        <SectionRanking />
      </main>
      <Footer />
    </>
  );
}